import { SxProps, Theme } from '@mui/material';

const modalContent: SxProps<Theme> = {
  padding: '24px',
  minWidth: '380px',
  border: '1px solid',
  borderColor: 'divider'
};

const initiateLaunchModalContent: SxProps<Theme> = {
  padding: '24px',
  width: '450px',
  border: '1px solid',
  borderColor: 'divider'
};

const dontShowAgainCheckbox: SxProps<Theme> = {
  marginTop: '16px',
  '& .MuiFormControlLabel-label': {
    fontSize: '14px',
    color: 'text.primary'
  }
};

const modalTitle: SxProps<Theme> = {
  fontSize: '24px',
  fontWeight: 600,
  lineHeight: '32px',
  marginBottom: '8px',
  color: 'text.primary'
};

const modalText: SxProps<Theme> = {
  fontSize: '16px',
  lineHeight: '24px',
  color: 'customGrey.dark',
  marginBottom: '24px'
};

// Aliases for semantic clarity
const modalSubtitle = modalText;
const modalWarning = modalText;

const buttonGroup: SxProps<Theme> = {
  display: 'flex',
  gap: '12px',
  flexWrap: 'wrap'
};

const primaryButton: SxProps<Theme> = {
  minWidth: '100px'
};

const outlinedButton: SxProps<Theme> = {
  minWidth: '100px',
  borderColor: 'primary.main',
  color: 'primary.main'
};

const textButton: SxProps<Theme> = {
  minWidth: '100px',
  color: 'primary.main'
};

const abortButton: SxProps<Theme> = {
  width: '100%',
  backgroundColor: 'error.main',
  color: 'common.white',
  '&:hover': {
    backgroundColor: 'error.dark'
  }
};

const countdownTitle: SxProps<Theme> = {
  fontSize: '28px',
  fontWeight: 600,
  lineHeight: '36px',
  marginBottom: '8px',
  color: 'text.primary'
};

const scheduleFieldLabel: SxProps<Theme> = {
  fontSize: '14px',
  fontWeight: 500,
  marginBottom: '4px',
  color: 'text.primary'
};

const scheduleFieldSubLabel: SxProps<Theme> = {
  fontSize: '12px',
  color: 'text.disabled',
  marginBottom: '8px'
};

const scheduleInput: SxProps<Theme> = {
  marginBottom: '16px'
};

const scheduleModalTitle: SxProps<Theme> = {
  fontSize: '24px',
  fontWeight: 600,
  lineHeight: '32px',
  marginBottom: '24px',
  color: 'text.primary'
};

const scheduleButtonGroup: SxProps<Theme> = {
  display: 'flex',
  gap: '12px',
  marginTop: '24px'
};

const validationErrorText: SxProps<Theme> = {
  fontSize: '14px',
  marginBottom: '8px',
  color: 'error.main'
};

const errorMessageContainer: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  marginBottom: '8px'
};

const errorMessageText: SxProps<Theme> = {
  fontSize: '14px',
  fontWeight: 700,
  color: 'error.main'
};

export const launchModalsSx = {
  modalContent,
  initiateLaunchModalContent,
  modalTitle,
  modalText,
  modalSubtitle,
  modalWarning,
  buttonGroup,
  primaryButton,
  outlinedButton,
  textButton,
  abortButton,
  countdownTitle,
  scheduleFieldLabel,
  scheduleFieldSubLabel,
  scheduleInput,
  scheduleModalTitle,
  scheduleButtonGroup,
  validationErrorText,
  dontShowAgainCheckbox,
  errorMessageContainer,
  errorMessageText
};
